import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const deletePackage = createAction(ACTION.DELETE_PACKAGE.REQUEST, (packageId, params = {}) => ({packageId, params}));
export const beginDeletePackage = createAction(ACTION.BEGIN_DELETE_PACKAGE, () => {});
export const endDeletePackage = createAction(ACTION.END_DELETE_PACKAGE, () => {});